hns('I18n.translations.ko', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 0,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n%u",
        "units": {
          "byte": "바이트",
          "gb": "기가바이트",
          "kb": "킬로바이트",
          "mb": "메가바이트",
          "tb": "테라바이트"
        }
      }
    }
  }
});

